exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".barButton{float:left;width:6em;border:1px solid #000;background:#fff;border-radius:5px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3876005a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/F3dButton.vue
// module id = 17
// module chunks = 0